import React from 'react';

const PolicySVG = ({ color, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ? width : '24'}
    height={height ? height : '24'}
    viewBox="0 0 24 24"
  >
    <path
      color={color ? color : '#ffffff'}
      fillRule="evenodd"
      d="M18,2 L6,2 C4.9,2 4,2.9 4,4 L4,20 C4,21.1 4.9,22 6,22 L18,22 C19.1,22 20,21.1 20,20 L20,4 C20,2.9 19.1,2 18,2 Z M6,4 L11,4 L11,12 L8.5,10.5 L6,12 L6,4 Z"
    />
  </svg>
);

export default PolicySVG;
